export default __webpack_public_path__ + "static/media/2019.9e674a6b.png";